'use client';

import { Button } from '@/components/ui/Button';
import Link from 'next/link';
import { customerMenuItems, footerLinks, menuItems } from '@/constant/navigation';
import { useTabContext } from '../context/TabContext';
import { usePathname, useRouter } from 'next/navigation';
import { AdviserButton } from '@/components/layout/AdviserButton';
import { CustomerButton } from '@/components/layout/CustomerButton';
import React, { memo } from 'react';
import MegaMenu from '@/components/ui/MegaMenu';

export const validLifetimeMortgagePaths = [
  '/professionals/lifetime-mortgages',
  '/professionals/lifetime-mortgages/sovereign',
  '/professionals/lifetime-mortgages/classic',
  '/professionals/lifetime-mortgages/heritage',
  '/professionals/lifetime-mortgages/emerald',
  '/professionals/lifetime-mortgages/lending-criteria',
];

const DesktopMenu = memo(function DesktopMenu() {
  const { selectedTab } = useTabContext();
  const pathname = usePathname();
  const router = useRouter();
  const handleContactClick = () => {
    if (selectedTab === 'adviser') {
      router.push('/professionals/contact-us');
    } else {
      router.push('/contact-us');
    }
  };
  const isLifetimeMortgages = validLifetimeMortgagePaths.includes(pathname);
  const logo = isLifetimeMortgages ? '/img/logo-2.svg' : '/img/logo.svg';

  return (
    <div
      className={`
        fixed top-[39px]
        w-full
        ${isLifetimeMortgages ? 'bg-[#0A1628]' : 'bg-white'}
        h-[6.62rem]
        xl:pb-[7.62rem]
        transition-colors
        duration-300
      `}>
      <div className="container hidden md:pt-[1.60rem] md:pb-[1.75rem] lg:flex lg:relative xl:pt-[1rem] xl:pb-[1.75rem]">
        <div className="flex items-center gap-x-4">
          <Link href={selectedTab === 'adviser' ? '/professionals' : '/'} className="py-4">
            <img src={logo} alt="Logo" />
          </Link>
        </div>

        <div className={`flex items-center ml-4 ${selectedTab === 'adviser' ? 'gap-x-4 xl:ml-12' : 'xl:ml-6'}`}>
          {(selectedTab === 'adviser' ? menuItems : customerMenuItems).map((item) => (
            <div key={item.title} className="relative hidden lg:block xl:justify-evenly">
              {item.submenu ? (
                <MegaMenu
                  title={item.title}
                  menuItems={item.submenu}
                  footerLinks={footerLinks}
                  contactText="Talk with our sales team"
                  contactButtonText="Contact us"
                  onContactClick={handleContactClick}
                />
              ) : (
                <Button variant="menu">
                  {item.title}
                </Button>
              )}
            </div>
          ))}
        </div>

        {selectedTab === 'adviser' ? <AdviserButton /> : <CustomerButton />}
      </div>
    </div>
  );
});

export default DesktopMenu;
